// src/LeaderboardPage.js
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom'; // Import useNavigate
import './LeaderboardPage.css';
import AstexLeaderboard from './AstexLeaderboard';
import SelfLeaderboard from './SelfLeaderboard';
import CrossLeaderboard from './CrossLeaderboard';

const LeaderboardPage = () => {
  const [selectedDataset, setSelectedDataset] = useState('astex');
  const navigate = useNavigate(); // Initialize useNavigate

  const renderLeaderboard = () => {
    switch (selectedDataset) {
      case 'astex':
        return <AstexLeaderboard />;
      case 'self':
        return <SelfLeaderboard />;
      case 'cross':
        return <CrossLeaderboard />;
      default:
        return <AstexLeaderboard />;
    }
  };

  const handleSubmitModelClick = () => {
    navigate('/submit-model'); // Navigate to the new route
  };

  return (
    <div className="leaderboard-page-container">
      <div className="leaderboard-header-controls"> {/* New wrapper for h1 and button */}
        <h1></h1>
        <button
          onClick={handleSubmitModelClick}
          className="submit-model-button"
        >
          Submit Your Model
        </button>
      </div>
      <div className="dataset-nav">
        <button
          className={selectedDataset === 'astex' ? 'nav-button active' : 'nav-button'}
          onClick={() => setSelectedDataset('astex')}
        >
          Astex
        </button>
        <button
          className={selectedDataset === 'self' ? 'nav-button active' : 'nav-button'}
          onClick={() => setSelectedDataset('self')}
        >
          PoseX-SD
        </button>
        <button
          className={selectedDataset === 'cross' ? 'nav-button active' : 'nav-button'}
          onClick={() => setSelectedDataset('cross')}
        >
          PoseX-CD
        </button>
      </div>

      <div className="leaderboard-content">
        {renderLeaderboard()}
      </div>
    </div>
  );
};

export default LeaderboardPage;